import clsx from 'clsx';
import React__default, { Component } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { I as Icons } from '../../../index-DRG3ZeD1.mjs';
import SvgMiscAi from './compiled/MiscAi.es.js';
import SvgMiscAiFill from './compiled/MiscAiFill.es.js';
import SvgNavAiChatbot from './compiled/NavAiChatbot.es.js';
import SvgMiscEvergreenAi from './compiled/MiscEvergreenAi.es.js';
import SvgMiscMcp from './compiled/MiscMcp.es.js';
import SvgNavMcp from './compiled/NavMcp.es.js';

const root = "_root_1w0hf_1";
const styles = {
	root: root
};

const MissingIcon = () => React__default.createElement(
  "svg",
  { "aria-label": "Could not load icon", "data-is-missing-icon": "true", viewBox: "0 0 24 24" },
  React__default.createElement("rect", { height: "24", width: "24", x: "0", y: "0" })
);
class IconErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      didFailToLoad: false
    };
  }
  static getDerivedStateFromError() {
    return {
      didFailToLoad: true
    };
  }
  render() {
    return this.state.didFailToLoad ? React__default.createElement(MissingIcon, null) : this.props.children;
  }
}
function getCssSize(size) {
  if (size === "small" || size === void 0) {
    return "24px";
  }
  if (size === "medium") {
    return "36px";
  }
  if (size === "large") {
    return "48px";
  }
  return size;
}
const Icon = ({ "aria-label": ariaLabel, color, isBlock = false, name, "aria-hidden": ariaHidden = true, canAcceptPointerEvents = true, shouldAnimateFill = true, size = "small", className }) => {
  const IconComponent = getIcon(name);
  const cssSize = getCssSize(size);
  return React__default.createElement(
    "span",
    { "aria-hidden": ariaHidden ? "true" : void 0, "aria-label": ariaLabel, className: clsx(styles.root, `zds-deprecated-icon-${name}`, className), "data-testid": "iconContainer", "data-zds": true, "data-block": isBlock, "data-pointer-events": canAcceptPointerEvents, "data-animate": shouldAnimateFill, style: {
      "--_zds-icon-height": cssSize,
      "--_zds-icon-width": cssSize,
      "--_zds-icon-fill": color ? Colors[color] : "currentColor"
    } },
    React__default.createElement(
      IconErrorBoundary,
      null,
      React__default.createElement(IconComponent, { size: cssSize, color, name })
    )
  );
};
function getIcon(name) {
  try {
    if (name === "miscAI") {
      return SvgMiscAi;
    }
    if (name === "miscAIFill") {
      return SvgMiscAiFill;
    }
    if (name === "navAIChatbot") {
      return SvgNavAiChatbot;
    }
    if (name === "miscEvergreenAI") {
      return SvgMiscEvergreenAi;
    }
    if (name === "miscMCP") {
      return SvgMiscMcp;
    }
    if (name === "navMCP") {
      return SvgNavMcp;
    }
    const capitalizedIcon = `${name[0].toUpperCase()}${name.substring(1)}`;
    return Icons[capitalizedIcon] || MissingIcon;
  } catch (_a) {
    return MissingIcon;
  }
}

export { Icon };
//# sourceMappingURL=Icon.es.js.map
